import styled, { css } from "styled-components";
import { media } from "../../index";
import { safeElement } from "../../utils";

var debug = false;

//
// GRID.BOX
export var Box = styled(safeElement()).withConfig({
  displayName: "atoms__Box",
  componentId: "sc-17ugkfi-0"
})(["box-sizing:border-box;display:flex;flex-direction:column;", ";", ";", ";", ";", ""], media.up.phone(css(["flex-basis:", ";order:", ";display:", ";align-items:", ";"], function (props) {
  return "calc(" + props.width[0] + " * 100%)";
}, function (_ref) {
  var order = _ref.order;
  return order[0];
}, function (_ref2) {
  var hide = _ref2.hide;
  return hide[0] ? "none" : "flex";
}, function (props) {
  return props.theme.typoTextAlign === "center" ? "center" : props.alignItems[0];
})), media.up.tablet(css(["flex-basis:", ";order:", ";display:", ";align-items:", ";"], function (props) {
  return "calc(" + props.width[1] + " * 100%)";
}, function (_ref3) {
  var order = _ref3.order;
  return order[1];
}, function (_ref4) {
  var hide = _ref4.hide;
  return hide[1] ? "none" : "flex";
}, function (props) {
  return props.theme.typoTextAlign === "center" ? "center" : props.alignItems[1];
})), media.up.desktop(css(["flex-basis:", ";order:", ";display:", ";align-items:", ";"], function (props) {
  return "calc(" + props.width[2] + " * 100%)";
}, function (_ref5) {
  var order = _ref5.order;
  return order[2];
}, function (_ref6) {
  var hide = _ref6.hide;
  return hide[2] ? "none" : "flex";
}, function (props) {
  return props.theme.typoTextAlign === "center" ? "center" : props.alignItems[2];
})), media.up.wide(css(["flex-basis:", ";order:", ";display:", ";align-items:", ";"], function (props) {
  return "calc(" + props.width[3] + " * 100%)";
}, function (_ref7) {
  var order = _ref7.order;
  return order[3];
}, function (_ref8) {
  var hide = _ref8.hide;
  return hide[3] ? "none" : "flex";
}, function (props) {
  return props.theme.typoTextAlign === "center" ? "center" : props.alignItems[3];
})), debug && "background-color: rgba(0,0,0,0.1);");

//
// GRID

var defaultGap = "2em";

export var Grid = styled(safeElement()).withConfig({
  displayName: "atoms__Grid",
  componentId: "sc-17ugkfi-1"
})(["display:flex;flex-direction:", ";justify-content:", ";align-items:", ";flex-flow:wrap;", " ", " ", " ", "{", " ", "}", ""], function (props) {
  return props.flexDirection;
}, function (props) {
  return props.justifyContent;
}, function (props) {
  return props.alignItems;
}, function (_ref9) {
  var gap = _ref9.gap;
  return "width: calc(100%  + " + (gap ? defaultGap : "0") + ");";
}, function (_ref10) {
  var gap = _ref10.gap;
  return "margin-left: calc(-" + (gap ? defaultGap : "0") + " / 2);";
}, function (_ref11) {
  var gap = _ref11.gap;
  return "margin-bottom: -" + (gap ? defaultGap : "0") + ";";
}, Box, function (_ref12) {
  var gap = _ref12.gap;
  return "padding: 0 calc(" + (gap ? defaultGap : "0") + " / 2);";
}, function (_ref13) {
  var gap = _ref13.gap;
  return "margin-bottom: " + (gap ? defaultGap : "0") + ";";
}, debug && "background-color: rgba(0,0,0,0.05);");